import Vue from 'vue';

Vue.filter('capitalize', value => {
    if (!value) {
        return "";
    }

    value = value.toString().toLowerCase();
        
    //replace any _ with space
    value = value.replace(/_/g, " ");
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('decode', value => {
    if (!value) {
        return "";
    }

    return unescape(value);
});

Vue.filter('lowercase', value => {
    if(!value){
        return "";
    }

    return value.toLowerCase();
});